import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper2,
    borderRadius: theme.shape.borderRadius,
    padding: '10px 15px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 10,
  },
  title: {
    fontSize: theme.typography.fontSize - 2,
    color: theme.palette.text.secondary,
    '@media (max-width: 1441px)': {
      display: 'none',
    },
  },
  value: {
    padding: 0,
    margin: 0,
    fontSize: theme.typography.fontSize + 6,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.primary,
  },
  goal: {
    fontSize: theme.typography.fontSize - 4,
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightBold,
  },
  goalContent: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
  },
}))

export default useStyles
